import { bootstrapVariantApp } from '@shared/app/bootstrap';
import './theme/theme.css';
import { osloCircularFastTrackVariantConfig } from './variant';

bootstrapVariantApp(osloCircularFastTrackVariantConfig);
